export default {
    apiURL: process.env.VUE_APP_ORIGIN === 'true' ? 'https://api.altezza.travel' : 'https://dev-api.altezza.travel',
}
